export class QPlaceHolder {
  constructor() {
    this.fPlaceHolderName = null;
    this.fChildren = null;
    this.fParent = null;
    this.fReportToRoot = false;

    // 1. One or more of the children will report to the placeholder
    // 2. The placeholder will report to the box the root of the placeholder reported

    // Cases:
    // 1. Single Manager for a placeholder - insert placeholder and having manager report to placeholder
    // 2. Multiple roots (same parent) for a placeholder - insert placeholder and roots report to placeholder
    // 3. Multiple roots (different parents) for a placeholder - pick first root and use for placeholder other roots attach to placeholder
  }

  SetReportToRoot(reportToRoot) {
    this.fReportToRoot = reportToRoot;
  }

  GetReportToRoot() {
    return this.fReportToRoot;
  }

  initPlaceHolder(qxDoc, fValue, anObj, parent) {
    var pH = qxDoc.fPlaceHolders;
    for (var pHolder in pH) {
      var newpHolder = pH[pHolder];
      if (newpHolder.fParent == parent && fValue == newpHolder.fPlaceHolderName) {
        newpHolder.fChildren.push(anObj);
        return;
      }
    }
    this.fChildren = [anObj];
    if (this.fParent == null) this.fParent = parent;
    pH.push(this);
    this.fPlaceHolderName = fValue;
  }
}
